document.querySelectorAll('.ApartmentItemListSmall').forEach((el) => {
    handle();

    function handle() {
        const more = el.querySelector('.ApartmentItemListSmall__more');
        if (more) {
            more.addEventListener('click', () => {
                fetch(more.dataset.url)
                    .then((r) => r.text())
                    .then((html) => {
                        more.outerHTML = html;
                        handle();
                        setTimeout(() => {
                            el.querySelectorAll('.ApartmentItem').forEach(ApartmentItemInit);
                            el.querySelectorAll('.ActionsList').forEach(ActionsListInit);
                        }, 100)
                    });
            })
        }
    }
});
